/**
 æ¥ææ§ä»¶é»è®¤éç½®
 éç½®è¯¦æåèï¼https://www.primefaces.org/primeng/#/calendar
 */
export class DatePickerOptions {
  selectionMode = 'single';
  placeholder = '';
  disabled = false;
  dateFormat = 'yy-mm-dd';
  inline = false;
  selectOtherMonths = true;
  showIcon = true;
  showOnFocus = true;
  readonlyInput = false;
  minDate = '';
  maxDate = '';
  disabledDates: Array<Date> = [];
  disabledDays: Array<number> = [];
  monthNavigator = false;
  yearNavigator = false;
  showTime = false;
  hourFormat = 24;
  timeOnly = false;
  dataType = 'date';
  required = false;
  showSeconds = false;
  yearRange = '1970:2100';
  locale = {
    firstDayOfWeek: 1,
    dayNames: ['ææä¸', 'ææäº', 'ææä¸', 'ææå', 'ææäº', 'ææå­', 'æææ¥'],
    dayNamesShort: ['å¨æ¥', 'å¨ä¸', 'å¨äº', 'å¨ä¸', 'å¨å', 'å¨äº', 'å¨å­'],
    dayNamesMin: ['æ¥', 'ä¸', 'äº', 'ä¸', 'å', 'äº', 'å­'],
    monthNames: ['ä¸æ', 'äºæ', 'ä¸æ', 'åæ', 'äºæ', 'å­æ', 'ä¸æ', 'å«æ', 'ä¹æ', 'åæ', 'åä¸æ', 'åäºæ'],
    monthNamesShort: ['1æ', '2æ', '3æ', '4æ', '5æ', '6æ', '7æ', '8æ', '9æ', '10æ', '11æ', '12æ'],
    today: 'ä»å¤©',
    clear: 'æ¸é¤'
  };
  showButtonBar = false;
}
